import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {ADVANCE_DIAGNOSTICS_UNIT} from 'presentation/pages/private/home/components/AdvanceDiagnosticsBooking/constants';

import {IsAdvanceDiagnosticsAppointmentParams} from './types';

export const isAdvanceDiagnosticsAppointment = ({
	appointment,
	isAdvanceDiagnosticsExamsJourneyEnabled,
}: IsAdvanceDiagnosticsAppointmentParams) =>
	isAdvanceDiagnosticsExamsJourneyEnabled &&
	appointment.bookingType === BookingTypeEnum.EXAM &&
	appointment.unitCode === ADVANCE_DIAGNOSTICS_UNIT.unitCode;
